import {BaseModel} from "./base-model";
import {Utils} from "../utils";
import {Role} from "./role";
import {environment} from "@environments/environment";

export class Personnel extends BaseModel {

  protected static self = Personnel;

  id: string;
  createdAt: number;
  lastAccessAt: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  prefix: string;
  phoneNumber: string;
  skills_uid: string[];
  field_services_uid: string[];
  available: boolean;
  fcm_token: string;
  roles: Role[];

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }

  public validate(): boolean {
    return !Utils.isEmpty(this.firstName) &&
           !Utils.isEmpty(this.lastName) &&
           !Utils.isEmpty(this.email) &&
            Utils.validateEmail(this.email) &&
           !Utils.isEmpty(this.phoneNumber) &&
            this.phoneNumber.length == 10
           // (!environment.parse.useParse || environment.parse.useParse && !Utils.isEmpty(this.id) || (environment.parse.useParse && Utils.isEmpty(this.id) && !Utils.isEmpty(this.password) && this.password.length >= 8))
           /*&& Utils.isEmpty(this.prefix) && this.prefix.match(/\+[0-9]+/g) != null*/;
  }
}
